const state = {
  prasymasID: null,
  prasymasTipas: '',
  prasymasBusena: '',
  prasymasBusenaTolimesne: '',
  prasymasReadonly: false,
  prasymasOwner: false,
  prasymasSignStatus: false,
  prasymasSistema: '',
  prasymasTeikejasRole: '',
  pagrindasKodas: null,
}

// getters
const getters = {
  prasymasID: state => state.prasymasID,
  prasymasTipas: state => state.prasymasTipas,
  prasymasBusena: state => state.prasymasBusena,
  prasymasBusenaTolimesne: state => state.prasymasBusenaTolimesne,
  prasymasReadonly: state => state.prasymasReadonly,
  prasymasOwner: state => state.prasymasOwner,
  prasymasSignStatus: state => state.prasymasSignStatus,
  prasymasSistema: state => state.prasymasSistema,
  prasymasTeikejasRole: state => state.prasymasTeikejasRole,
  pagrindasKodas: state => state.pagrindasKodas,
}

// actions
const actions = {
  prasymasID({ commit }, payload) {
    commit('prasymasID', payload)
    sessionStorage.setItem(
      'prasymasID',
      parseInt(payload) ? JSON.stringify(payload) : null
    )
  },
  prasymasTipas({ commit }, payload) {
    commit('prasymasTipas', payload)
    sessionStorage.setItem('prasymasTipas', JSON.stringify(payload))
  },
  prasymasBusena({ commit }, payload) {
    commit('prasymasBusena', payload)
    sessionStorage.setItem('prasymasBusena', JSON.stringify(payload))
  },
  prasymasBusenaTolimesne({ commit }, payload) {
    commit('prasymasBusenaTolimesne', payload)
    sessionStorage.setItem('prasymasBusenaTolimesne', JSON.stringify(payload))
  },
  prasymasReadonly({ commit }, payload) {
    commit('prasymasReadonly', payload)
    sessionStorage.setItem('prasymasReadonly', JSON.stringify(payload))
  },
  prasymasOwner({ commit }, payload) {
    commit('prasymasOwner', payload)
    sessionStorage.setItem('prasymasOwner', JSON.stringify(payload))
  },
  prasymasSignStatus({ commit }, payload) {
    commit('prasymasSignStatus', payload)
    sessionStorage.setItem('prasymasSignStatus', JSON.stringify(payload))
  },
  prasymasSistema({ commit }, payload) {
    commit('prasymasSistema', payload)
    sessionStorage.setItem('prasymasSistema', JSON.stringify(payload))
  },
  prasymasTeikejasRole({ commit }, payload) {
    commit('prasymasTeikejasRole', payload)
    sessionStorage.setItem('prasymasTeikejasRole', JSON.stringify(payload))
  },
  pagrindasKodas({ commit }, payload) {
    commit('pagrindasKodas', payload)
    sessionStorage.setItem('pagrindasKodas', JSON.stringify(payload))
  },
}

// mutations
const mutations = {
  prasymasID(state, data) {
    state.prasymasID = data
  },
  prasymasTipas(state, data) {
    state.prasymasTipas = data
  },
  prasymasBusena(state, data) {
    state.prasymasBusena = data
  },
  prasymasBusenaTolimesne(state, data) {
    state.prasymasBusenaTolimesne = data
  },
  prasymasReadonly(state, data) {
    state.prasymasReadonly = data
  },
  prasymasOwner(state, data) {
    state.prasymasOwner = data
  },
  prasymasSignStatus(state, data) {
    state.prasymasSignStatus = data
  },
  prasymasSistema(state, data) {
    state.prasymasSistema = data
  },
  prasymasTeikejasRole(state, data) {
    state.prasymasTeikejasRole = data
  },
  pagrindasKodas(state, data) {
    state.pagrindasKodas = data
  },
}

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
}
